/* eslint-disable react/prop-types */ // TODO: add props
import { useState } from 'react';
import { Table } from 'edrolo/domains/teacherResultsTable';
import { Link } from 'react-router-dom';
import style from './QuestionColumnHeader.scss';
import QuestionInstructionsModal from '../QuestionInstructionsModal';
import { EXAM_ANALYTICS_CONSTANTS } from 'edrolo/domains/exams';

const LEFT_CLICK = 0;

const QuestionColumnHeader = ({
  examId,
  question,
  questionReviewUrl,
  analyticsPayload,
}) => {
  const [show, setShow] = useState(false);

  return (
    <Table.ColHeader isSticky className={style.questionHeader}>
      <Link
        className={style.questionSerialHeader}
        data-test="show-question-modal"
        to={questionReviewUrl}
        onClick={(e) => {
          if (e.button === LEFT_CLICK) {
            e.preventDefault();
            setShow(true);

            global.analytics.track(
              EXAM_ANALYTICS_CONSTANTS.EVENTS.OPENED_QUESTION_INFORMATION_MODAL,
              {
                origin: analyticsPayload.origin,
                page: analyticsPayload.page,
                class_id: analyticsPayload.classId,
                lesson_id: analyticsPayload.lessonId,
                exam_id: analyticsPayload.examId,
                question_id: question.get('id'),
              }
            );
          }
        }}
      >
        {question.get('full_serial')}
      </Link>
      <QuestionInstructionsModal
        examId={examId}
        question={question}
        show={show}
        onCancel={() => setShow(false)}
        questionReviewUrl={questionReviewUrl}
        analyticsPayload={analyticsPayload}
      />
    </Table.ColHeader>
  );
};

export default QuestionColumnHeader;
